module.exports = __webpack_public_path__ + "img/clouds.0521b351.png";